import React, {Component} from 'react';
import {api} from "./rest";
import linkState from "./state";
import "./Reports.css";
import moment from "moment";

export default class Reports extends Component {
	constructor(props, context) {
		super(props, context);
		this.linkState = linkState.bind(this)
		this.state = {
			from: moment().weekday(0).format("YYYY-MM-DD"),
			to: moment().weekday(6).format("YYYY-MM-DD"),
			filter: "destino",
			search: "",
			buses: [],
			models: [],
			contractors: []
		}
	}

	componentWillMount () {
		api.get("/buses/all")
		.then((response)=>{
		    this.setState({buses: response.data})
		});
		api.get("/models/all")
		.then((response)=>{
			this.setState({models: response.data})
		});
		api.get("/contractors")
		.then((response)=>{
			this.setState({contractors: response.data})
		});
	}

	handleSearch(e) {
		e.preventDefault();
		const tempWindow = window.open();
		let {from, to, search, filter} = this.state;
		api.get("search", {
			params: {
				from: `${from} 00:00:00`,
				to: `${to} 23:59:00`,
				search,
				filter
			}
		})
		.then((response)=> {
			if(window.location.hostname === "localhost") {
				tempWindow.location.href = `http://localhost:8000/reports?token=${response.data.token}`;
			} else {
				tempWindow.location.href = `/api/reports?token=${response.data.token}`;
			}
		})
		.catch(console.error.bind(console))
	}

	render() {
		let busqueda;
		if (this.state.filter === "folio" || this.state.filter === "salida") {
			busqueda = (
				<input type="text" value="" disabled/>
			)
		} else if (this.state.filter === "autobus") {
			busqueda = (
				<select {...this.linkState("search")}>
					<option value={0}>Todos</option>
					<option value={-1}>Propios</option>
					<option value={-2}>Externos</option>
					{this.state.buses.map(bus=>(
						<option value={bus.id}>{bus.name}</option>
					))}
				</select>
			)
		} else if (this.state.filter === "modelo") {
			busqueda = (
				<select {...this.linkState("search")}>
					<option value={0}>Todos</option>
					<option value={-1}>Propios</option>
					<option value={-2}>Externos</option>
					{this.state.models.map(model=>(
						<option value={model.id}>{model.name}</option>
					))}
				</select>
			)
		} else if (this.state.filter === "contratante") {
			busqueda = (
				<select {...this.linkState("search")}>
					<option value={0}>Todos</option>
					{this.state.contractors.map(contractor=>(
						<option value={contractor.id}>{contractor.name}</option>
					))}
				</select>
			)
		} else {
			busqueda = (
				<input type="text" {...this.linkState("search")}/>
			)
		}
		return (
			<form className="row small-12 align-center" onSubmit={this.handleSearch.bind(this)}>
				<div className="columns small-12 medium-6">
					<div className="row" style={{
						height: "calc(100vh - 100px)",
						alignItems: "center",
						alignContent: "center",
					}}>
						<label className="columns small-6">
							<em>Filtro</em>
							<select {...this.linkState("filter",{onChange: (e)=>{
								if (e.target.value === "modelo") {
									this.setState({search: this.state.models[0].id});
								}
								if (e.target.value === "autobus") {
									this.setState({search: this.state.buses[0].id});
								}
								if (e.target.value === "contratante") {
									this.setState({search: this.state.contractors[0].id});
								} else {
									this.setState({search: ""});
								}
								return e.target.value;
							}})}>
								<option value={"autobus"}>Autobus</option>
								<option value={"contratante"}>Contratante</option>
								<option value={"destino"}>Destino</option>
								<option value={"folio"}>Folio</option>
								<option value={"modelo"}>Modelo</option>
								<option value={"salida"}>Salida</option>
							</select>
						</label>
						<label className="columns small-6">
							<em>Busqueda</em>
							{busqueda}
						</label>
						<label className="columns small-6">
							<em>Inicio del reporte</em>
							<input type="date" {...this.linkState("from")}/>
						</label>
						<label className="columns">
							<em>Final del reporte</em>
							<input type="date" {...this.linkState("to")} min={this.state.from}/>
						</label>
						<label className="columns">
							<em> </em>
							<button type="submit" className="button expanded success">Generar</button>
						</label>
					</div>
				</div>
			</form>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Reports.js
 **/